import React from 'react';
import {
    Button,
    Form,
    Input,
    Icon,
    Segment,
    Grid,
    List,
    Loader,
    Header,
    Radio,
    Select,
    Message,
    Card,
    Divider
} from 'semantic-ui-react';
import axios from 'axios';
import { FormattedMessage } from 'react-intl';
import { DateTimePicker } from 'react-widgets';
import { ToastContainer } from 'react-toastify';


export default class OfferedMultipleAnswerQuestionCommentForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            answer:{value: ''},
            answers: []

        };
        this.handleInputChange = this.handleInputChange.bind(this);

    }

    componentDidMount() {

    }



    handleChange = (e, { value }) => { //console.log(this.state.value);       //
        this.setState({ value })};
    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }

    render() {

        return (
            <div>

                <Form>
                    <Form.Group >
                        <Form.Field width={16}  error={this.state.titleErr}>
                            <label>
                                {<FormattedMessage id="poll.question" />}
                                {/*Pitanje*/}
                            </label>
                            <FormattedMessage id="poll.placeholderQuestion">
                                {(msg) => (<input

                                    fluid
                                    placeholder={msg}
                                    control={Input}
                                    value={this.state.title}
                                    name="text"
                                    onChange={(e) => this.setState({ text: e.target.value })}

                                />)}
                            </FormattedMessage>


                        </Form.Field>
                    </Form.Group>


                    <Form.Group >

                        <Form.Field width={10}>
                            <label>
                                {<FormattedMessage id="poll.offeredAnswers" />}
                                {/*Ponuđeni odgovor*/}
                            </label>
                            <FormattedMessage id="poll.placeholderOfferedAnswer">
                                {(msg) => (<input

                                    fluid
                                    placeholder={msg}
                                    control={Input}
                                    value={this.state.answer.value}
                                    name="answer"
                                    onChange={(e) => {
                                        this.setState({ answer: {value:e.target.value} });
                                    }
                                    }


                                />)}
                            </FormattedMessage>

                        </Form.Field>



                        <Form.Field  width={2} error={this.state.titleErr}>
                            <label>
                                <br/>
                            </label>
                            <Button primary fluid basic onClick={() => {
                                let answers =[...this.state.answers]
                                answers.push(this.state.answer)
                                this.setState({answers,  answer: {value: ''}});
                            } } > {<FormattedMessage id="poll.addAnswerButton" />} </Button>
                        </Form.Field>



                        <Form.Field width={4}>
                            <label>
                                {<FormattedMessage id="poll.section" />}
                            </label>
                            <Form.Dropdown
                                clearable
                                placeholder={<FormattedMessage id="common.section" />}
                                value={this.state.type}
                                onChange={this.handleInputChange}
                                name="section"
                                options={this.props.sections}
                                search
                                fluid
                                selection

                                error={this.state.sectionErr}
                            />
                        </Form.Field>
                    </Form.Group>



                </Form>
                <List divided verticalAlign='middle'>
                    {this.state.answers.map((e, index) =>(
                        <List.Item>
                            <List.Content floated='right'>
                                <Button basic color='red' size='mini' circular icon='trash alternate' onClick={()=>{
                                    let answers = [...this.state.answers]
                                    answers.splice(index, 1);
                                    this.setState({answers: answers})

                                }}/>
                            </List.Content>

                            <List.Content>{e.value}</List.Content>
                        </List.Item>))
                    }


                </List>

                <Button
                    onClick={this.props.closeQuestionForm}
                    floated="right"
                    color="blue"
                    basic
                >
                    {<FormattedMessage id="poll.cancel" />}
                </Button>
                <Button
                    onClick={()=>this.props.createQuestion(this.state.text, this.state.section,false,null,null,this.state.answers)}
                    floated="right"
                    color="blue"
                    primary
                >
                    {<FormattedMessage id="poll.addQuestionButton" />}
                </Button>



            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Poll/AdminPoll/QuestionForms/showOfferedMultipleAnswerQuestionCommentForm.js